import TypicalDrawingStorageContainer from "./DocumentManagement";
export default TypicalDrawingStorageContainer;
